import { loadFmac } from "@/api/riak/fmac.api";
import { loadHotSpots } from "@/api/forecast/hotspots.api";
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

const state = {
  fireRisk: [],
  hotSpots: []
};

const mutations = {
  setFireRisk(state, data){
    state.fireRisk = data ? data :  [];
  },
  setHotSpots(state, data){
    state.hotSpots = data ? data :  [];
  },
};

const actions = {
  async loadHotSpots( {commit}, payload ){
    const {location_id} = payload;
    try{
      const response = await loadHotSpots(location_id);
      commit('setHotSpots', response.data)
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações de focos de calor.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setHotSpots', undefined)
    }
  },

  async loadFmac( {commit}){
    try{
      const response = await loadFmac();
      commit('setFireRisk', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações de risco de incêndios.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setFireRisk', undefined);
    }
  },
};

const getters = {
  fireRisk: (state) => state.fireRisk,
  hotSpots: (state) => state.hotSpots,
};

export default {
  state,
  mutations,
  actions,
  getters
}
